import type {ApiWorkforceProfileRecord} from '../WorkforceProfiles/workforceProfileApiTypes';

import type {RequiredLanguageProfile} from '../../../../../types/shared-types';


export const mapRequiredLanguageProfile = (raw: unknown): RequiredLanguageProfile | null => {
  if (!raw || typeof raw !== 'object') {
    return null;
  }

  const profile = raw as Record<string, string | undefined>;
  const en = profile.en?.trim() || profile.enUs?.trim();
  const de = profile.de?.trim();

  if (!en && !de) {
    return null;
  }

  return {
    en: en ?? de ?? '',
    de: de ?? en ?? '',
  };
};

export const mapBilingualRationale = (rationale: unknown): RequiredLanguageProfile | null => {
  if (typeof rationale === 'string' && rationale.trim()) {
    const text = rationale.trim();

    return {en: text, de: text};
  }

  return mapRequiredLanguageProfile(rationale);
};

export const mapInferredCulturalRationale = (entry: ApiWorkforceProfileRecord): RequiredLanguageProfile | null => {
  const en = (entry.rationaleEn as string | undefined)?.trim();
  const de = (entry.rationaleDe as string | undefined)?.trim();

  if (en || de) {
    return {
      en: en ?? de ?? '',
      de: de ?? en ?? '',
    };
  }

  return mapBilingualRationale(entry.rationale);
};

export const mapLocalizedTextField = (raw: unknown): RequiredLanguageProfile => {
  if (typeof raw === 'string' && raw.trim()) {
    const text = raw.trim();
    return {en: text, de: text};
  }

  const profile = mapRequiredLanguageProfile(raw);
  if (profile) {
    return profile;
  }

  return {en: '', de: ''};
};
